module.exports = __webpack_public_path__ + "static/media/95FE8323-610C-43E5-8E77-4A9F9753551F-min.10d2d4d8.jpg";